import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Toggle } from '@kaleyra/emmy';

import Styles from './CallbackRequiredProfile.module.scss';
import { useToggle } from '../hooks/use-toggle';

interface RequiredProfileProps {
	requiredProfileData: string | null;
	setRequiredProfileData: (value: string | null) => void;
}

const CallbackRequiredProfile: React.FC<RequiredProfileProps> = ({
	requiredProfileData,
	setRequiredProfileData,
}) => {
	const { t } = useTranslation();

	const [status, toggle] = useToggle(requiredProfileData !== null);

	React.useEffect(() => {
		if (!status) setRequiredProfileData(null);
	}, [status]);

	return (
		<div>
			<div className={Styles.containerCallbackRequiredText}>
				<div className={Styles.compHeader}>
					{t('enableCallbackRequiredOptions')}
				</div>
				<div>
					<Toggle onClick={toggle} checked={status} />
				</div>
			</div>
			{status && (
				<EnabledContent
					requiredProfileData={requiredProfileData}
					setRequiredProfileData={setRequiredProfileData}
				/>
			)}
		</div>
	);
};

const EnabledContent: React.FC<RequiredProfileProps> = ({
	requiredProfileData,
	setRequiredProfileData,
}) => {
	const { t } = useTranslation();

	// Generic handle change function which takes as input the key that needs to be
	// changed and return a function which change the state of the parent with a callback
	const handleChange: React.ChangeEventHandler<HTMLInputElement> = ({
		target: { value },
	}) => setRequiredProfileData(value);

	return (
		<Input
			value={requiredProfileData ?? ''}
			onChange={handleChange}
			label={t('enterResponseMessage')}
			placeholder={t('enterResponseMessage')}
			className={Styles.mrgBtm}
		/>
	);
};

export default CallbackRequiredProfile;
